import { render, staticRenderFns } from "./SidebarContentEdit.vue?vue&type=template&id=86487212&"
import script from "./SidebarContentEdit.vue?vue&type=script&lang=js&"
export * from "./SidebarContentEdit.vue?vue&type=script&lang=js&"
import style0 from "./SidebarContentEdit.vue?vue&type=style&index=0&id=86487212&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports